import React from "react";
import KPI from "./KPI";

function EditPerformanceIndicator({
  account_slug,
  project_id,
  projectStatus,
  outcomes,
  account_id,
  indicators,
  setIndicatorUpdated,
  statuses,
  currentStatus,
  authorizationCode,
}) {
  return (
    <KPI
      account_slug={account_slug}
      project_id={project_id}
      projectStatus={projectStatus}
      outcomes={outcomes}
      account_id={account_id}
      indicators={indicators}
      setIndicatorUpdated={setIndicatorUpdated}
      statuses={statuses}
      currentStatus={currentStatus}
      authorizationCode={authorizationCode}
    />
  );
}

export default EditPerformanceIndicator;
